module.exports = __webpack_public_path__ + "img/hxjh_icon.f6a32fdc.png";